import React from "react";
import PropTypes from "prop-types";

/**
 * AvatarPreview
 * Componente premium para exibição de fotos de perfil com fallback para iniciais.
 * Garantido para manter formato perfeitamente circular e não encolher em contêineres flexbox.
 */
const AvatarPreview = ({ src, alt, size = "md", className = "", fallbackType = "initials", style = {}, ...props }) => {

    // Configurações de tamanho baseadas nas classes do NEO Admin
    const sizeClasses = {
        xs: "avatar-xs",
        sm: "avatar-sm",
        md: "avatar-md",
        lg: "avatar-lg",
        xl: "avatar-xl"
    };

    // rounded-circle adicionado no wrapper para garantir que qualquer borda externa siga o formato circular da imagem
    const wrapperClass = `${sizeClasses[size] || "avatar-md"} rounded-circle flex-shrink-0 ${className}`;

    if (src) {
        return (
            <div className={wrapperClass} style={{ ...style, flexShrink: 0 }} {...props}>
                <img
                    src={src}
                    alt={alt}
                    className="img-fluid rounded-circle w-100 h-100"
                    style={{ objectFit: "cover" }}
                />
            </div>
        );
    }

    // Fallback: Iniciais do nome ou ícone
    const initials = (alt && fallbackType === "initials") ? alt.charAt(0).toUpperCase() : "";

    return (
        <div className={wrapperClass} style={{ ...style, flexShrink: 0 }} {...props}>
            <span className="avatar-title rounded-circle bg-light-soft text-primary font-size-18">
                {initials || <i className="mdi mdi-account"></i>}
            </span>
        </div>
    );
};

AvatarPreview.propTypes = {
    src: PropTypes.string,
    alt: PropTypes.string,
    size: PropTypes.oneOf(["xs", "sm", "md", "lg", "xl"]),
    className: PropTypes.string,
    fallbackType: PropTypes.string,
    style: PropTypes.object
};

export default AvatarPreview;
